<template>
    <div class="slide"
         :class="{ active: isActive }">
        <div v-if="isVideo(slide)"
             class="slide-inner">
            <div class="mask"></div>
            <video ref='video' :poster="slide.poster" autoplay loop>
                <source v-for="src in slide.sources"
                        :src="src"
                        :type="getVideoType(src)" />
            </video>
        </div>
        <div v-else
             class="slide-inner">
             <img :src="slide" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Slider',
    props: [ 'isActive', 'slide' ],
    methods: {
        isVideo: function(slide) {
            return typeof(slide) == "object" ? true: false;
        },
        getVideoType: function(src) {
            let ext = src.split(".").pop();
            return `video/${ ext }; codecs="avc1.4D401E, mp4a.40.2"`;
        },
    },
    mounted: function() {
      this.$refs.video.muted = 'muted';
    },
}
</script>

<style scoped
       lang="scss">
    @import "../../static/styles/palette.scss";

    .slide {
        position: relative;
        width: 100%;
        height: 100%;
        display: none;

        & .slide-inner {
            position: relative;
            width: 100%;
            height: 100%;
            background-size: 100% 100%;
            background-position: center;
            background-size: cover;

            & .mask {
                position: absolute;
                width: 100%;
                height: 100%;
                background-color: $blue;
                opacity: 0.8;
                z-index: 3;
            }

            & video {
                position: relative;
                top: 50%;
                left: 88%;
                min-width: 100%;
                min-height: 100%;
                width: auto;
                height: auto;
                transform: translateX(-88%) translateY(-50%);
                z-index: 2;
            }

            & img {
                position: relative;
                top: 50%;
                left: 50%;
                min-width: 100%;
                min-height: 100%;
                width: auto;
                height: auto;
                transform: translateX(-50%) translateY(-50%);
            }
        }
    }

    .slide.active {
        display: block!important;
    }
</style>



// WEBPACK FOOTER //
// Slide.vue?b1aef36c